import React from 'react';

export default function DevisSummary({
  nbPersonnes,
  sousTotalPrestation,
  options,
  remise,
  montantRemise,
  total
}) {
  return (
    <div className="grid mt-2">
      <div className="col-12">
        <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: "10px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#6b7280", marginBottom: "4px" }}>
            <span>Prestation ({nbPersonnes} pers.)</span>
            <span style={{ fontWeight: 500 }}>{sousTotalPrestation.toFixed(2)} €</span>
          </div>
          {options.map((opt, idx) => (
            <div key={idx} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#6b7280", marginBottom: "4px" }}>
              <span>{opt.titre || "Option"}</span>
              <span style={{ fontWeight: 500 }}>{opt.prix.toFixed(2)} €</span>
            </div>
          ))}
          {remise > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#dc2626", marginBottom: "4px" }}>
              <span>Remise ({remise}%)</span>
              <span style={{ fontWeight: 500 }}>- {montantRemise.toFixed(2)} €</span>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "8px", fontWeight: 600, fontSize: "14.5px", color: "#322915" }}>
            <span>Total TTC</span>
            <span>{total.toFixed(2)} €</span>
          </div>
        </div>
      </div>
    </div>
  );
}